var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-sortable", "tag-attributes": _vm.sortableAttributes } },
    [
      _vm.view.Columns.length == 0
        ? _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _vm._v(_vm._s(_vm.$ct("no-columns-made-yet"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.view.Columns, function (col) {
        return _c(
          "w-list-item",
          { key: col.key },
          [
            _c("w-list-item-text", [_vm._v(_vm._s(col.Name))]),
            _c(
              "w-list-item-action",
              [
                _c(
                  "w-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.editCol(col)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "pen" } })],
                  1
                ),
              ],
              1
            ),
            _c(
              "w-list-item-action",
              [
                _c(
                  "w-button",
                  {
                    staticClass: "danger",
                    on: {
                      click: function ($event) {
                        return _vm.deleteCol(col)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "trash" } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "w-list-item",
        {
          on: {
            click: function ($event) {
              return _vm.createCol()
            },
          },
        },
        [
          _c("w-list-item-icon", [_c("w-fa", { attrs: { icon: "plus" } })], 1),
          _c("w-list-item-text", [_vm._v(_vm._s(_vm.$ct("add-column")))]),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditColumn != null } },
        [
          _vm.toEditColumn
            ? _c("app-column-edit", {
                attrs: {
                  value: _vm.toEditColumn,
                  "available-columns": _vm.availableColumns,
                  "is-new": _vm.toEditIsNew,
                },
                on: {
                  input: function ($event) {
                    return _vm.onEditInput($event)
                  },
                  close: function ($event) {
                    _vm.toEditColumn = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }